export default class Tag {
  constructor(data) {
    if (data && data.fields) {
      const { tag } = data.fields;
      this.tag = tag;
    }
  }
}
